export const dbVersion: number = 1;
export const webAppVersion: string = '1.0.1';
export const dbName: string = 'RavCreditMerchantDB';

export const dbAuthStore: string = 'mAuthStore';
export const dbUsersStore: string = 'mUsersStore';
export const dbContractsStore: string = 'mContractsStore';
export const dbClientsStore: string = 'mClientsStore';
export const dbBusinessInfo: string = 'mBusinessInfo';
export const dbBusinessConfig: string = 'mBusinessConfig';
export const dbConektaClientsStore: string = 'mConektaClientsStore';
export const dbConektaReferencesStore: string = 'mConektaReferencesStore';
export const dbPassportReferencesStore: string = 'mPassportReferencesStore';
export const dbDynamicReferencesStore: string = 'mDynamicReferencesStore';
export const dbDynamicAccountStore: string = 'mDynamicAccountStore';
export const dbNotificationsStore: string = 'mNotificationsStore';
export const dbPaymentsStore: string = 'mPaymentsStore';

export const dbIndexAuth: string = 'mAuth';
export const dbIndexUsers: string = 'mUsers';
export const dbIndexContracts: string = 'mContracts';
export const dbIndexClients: string = 'mClients';
export const dbIndexBusiness: string = 'mBusiness';
export const dbIndexConektaClients: string = 'mConektaClients';
export const dbIndexConektaClientsRef: string = 'mConektaClientsRef';
export const dbIndexPassportClientsRef: string = 'mPassportClientsRef';
export const dbIndexNotification: string = 'mNotification';
export const dbIndexPayments: string = 'mPayments';

export const keyPathId: string = 'id';
export const keyPathDynamicReference: string = 'charge.reference';
export const keyPathReference: string = 'reference';
export const keyPathCurp: string = 'curp';

export const keyUserID: string = 'rc_uid';
export const keyDBVersion: string = 'rc_vn';

export const dateFormat = 'EEEE, dd MMM yyyy';
export const dateCompleteFormat = 'EEEE, dd MMM yyyy  hh:mm aaaa';
export const timeFormat = 'hh:mm aaaa';

export const expiredPayment = 'expiredPayment';
export const lastPayment = 'lastPayment';
